import { useEffect, useState, type ReactElement } from 'react';
import { formatDateTime } from '@/lib/date-utils';

/**
 * "Example: <now in `zone`>", ticking every second, in the user's absolute
 * format. Its parent re-renders it on a zone or format change
 * (`useDisplayTimeZone` subscribes to both).
 */
export function ZoneExample({
  zone,
  testId,
}: {
  zone: string;
  testId: string;
}): ReactElement {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <p className="text-xs text-muted-foreground" data-testid={testId}>
      Example: {formatDateTime(now, zone)}
    </p>
  );
}
